import translations from './titanium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/titanium'

export const titanium: Metal = {
  id: 34,
  slug: 'titanium',
  name: t.name,
  symbol: 'Ti',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Panzhihua, titanium mine (China)',
      region: 'Panzhihua',
      coordinates: [101.72, 26.58],
    },
    {
      name: 'Moma, titanium mine (Mozambique)',
      region: 'Moma',
      coordinates: [39.64, -16.53],
    },
    {
      name: 'Richards Bay, titanium mine (South Africa)',
      region: 'Richards Bay',
      coordinates: [32.05, -28.78],
    },
    {
      name: 'Sokndal, titanium mine (Norway)',
      region: 'Sokndal',
      coordinates: [6.27, 58.34],
    },
    {
      // No Malagasy lake of this name; pinned on the QMM/Mandena ilmenite mine.
      name: 'Lake Ambrose, titanium mine (Madagascar)',
      region: 'Lake Ambrose',
      coordinates: [47.01, -24.96],
    },
    {
      name: 'Mombasa, titanium mine (Kenya)',
      region: 'Mombasa',
      coordinates: [39.67, -4.05],
    },
    {
      name: 'Havre-Saint-Pierre, titanium mine (Canada)',
      region: 'Havre-Saint-Pierre',
      coordinates: [-63.6, 50.24],
    },
  ],
  countries: [
    { name: 'China', percent: 35 },
    { name: 'Mozambique', percent: 20 },
    { name: 'South Africa', percent: 15 },
    { name: 'Australia', percent: 6 },
    { name: 'Norway', percent: 4 },
    { name: 'Canada', percent: 4 },
  ],
  // Vanadium is alloyed into the titanium premium phone frames use.
  related: ['vanadium'],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 2, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
